import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Autocomplete, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Formik, Form } from "formik";
import { userid, currentTenant, ccountry, einvoice } from "../../Common/Credentials.js";
import InventoryService from "../../inventory/InventoryService.js";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices.js";
import DepartmentServices from "../../Masters/Department/DepartmentServices.js";
import CategoryServices from "../../Masters/Category/CategoryServices.js";
import UomServices from "../../Masters/Uom/UomServices.js";
import UserService from "../../users/UserService.js";
import TransporterServices from "../../Masters/Transporter/TransporterServices.js";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'

const AddStockIssue = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pagename } = location.state || { pagename: 'New Stock Issue' };

  const [state, setState] = useState({
    stockissuetype: "Store",
    stockissuetypelist: ["Store", "OrgUnit"],
    id: "",
    WarehouseList: [],
    whdata: [],
    whid: '',
    warehouse: '',
    towarehouse: "",
    towhid: "",
    departmentList: [],
    department: '',
    deptid: '',
    userList: [],
    userdetails: [],
    reciver: '',
    reciverid: '',
    CategoryList: [],
    category: '',
    catid: '',
    itemsList: [],
    itemid: '',
    itemname: '',
    filteritemlist: [],
    additemsList: [],
    cost: '',
    hsn: '',
    quantity: '',
    UOMList: [],
    avlquantity: "",
    uom: '',
    uomid: "",
    brand: '',
    model: '',
    discription: '',
    to: '',
    loader: false,
    filteritems: [],
    selectbutton: false,
    transportername: null,
    deliverymethods: [
      { value: "1", name: "Own Vehicle" },
      { value: "2", name: "Hired Vehicle" },
      { value: "3", name: "GTA" },
      { value: "4", name: "Others" },
    ],
    transmode: 1,
    vehicletypes: [
      { value: "O", name: "ODC" },
      { value: "R", name: "Regular" },
    ],
    vehicletype: "R",
    vehiclenum: null,
    distance: 0,
    transporterselectiontype: false,
    transporterid: null,
    transporterslist: [],
    QRcode: "",
    ewaybillQRcode: "",
    ewaybilldata: "",
    supplytype: "I",
    transportationmode: "1",
    transactiontype: 1,
    ewaybillrequired: false,
    transidreq: false,
    validtrnsid: false,
    err: false,
  });

  const [hovered, setHovered] = useState(null);

  const updateState = (updates) => {
    setState(prev => ({ ...prev, ...updates }));
  };

  useEffect(() => {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      navigate('/');
      return;
    }

    WarehouseServices.getWarehouses(currentTenant)
      .then((response) => updateState({ WarehouseList: response.data }))
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate('/');
        }
      });

    CategoryServices.getCategory(currentTenant).then((response) =>
      updateState({ CategoryList: response.data.filter((e) => e.categorytype === "Product") })
    );

    UomServices.getUOM(currentTenant).then((response) =>
      updateState({ UOMList: response.data })
    );

    InventoryService.GetDataToAddStock(currentTenant).then((res) =>
      updateState({ itemsList: res.data })
    );

    InventoryService.GetItemsforStockissue(currentTenant).then(res =>
      updateState({ whdata: res.data })
    );

    UserService.Userwhanddpt(currentTenant).then((res) => {
      updateState({ userdetails: res.data });
    });

    TransporterServices.getTransporters(currentTenant).then((response) =>
      updateState({ transporterslist: response.data })
    );
  }, [navigate]);

  // Handlers
  const handlewarehouse = (event, newValue) => {
    if (newValue && typeof newValue === 'object') {
      if (newValue.id === state.towhid) {
        Swal.fire('', 'Cannot transfer to the same Org Unit');
      } else {
        updateState({ whid: newValue.id, warehouse: newValue.name });
        if (state.stockissuetype === "Store") {
          DepartmentServices.deptbywarehouse(newValue.id).then((response) =>
            updateState({ departmentList: response.data })
          );
        }
      }
    } else {
      updateState({ whid: '', warehouse: '' });
    }
  };

  const handleTowarehouse = (event, newValue) => {
    if (newValue && typeof newValue === 'object') {
      if (newValue.id === state.whid) {
        Swal.fire('', 'Cannot transfer to the same Org Unit');
      } else {
        updateState({ towhid: newValue.id, towarehouse: newValue.name });
        updateState({ userList: state.userdetails.filter((e) => e.whid === newValue.id) });
      }
    } else {
      updateState({ towhid: '', towarehouse: '' });
    }
  };

  const handledept = (event, newValue) => {
    if (newValue && typeof newValue === 'object') {
      updateState({
        department: newValue.name,
        deptid: newValue.id,
      });
      updateState({
        userList: state.userdetails.filter((e) => e.whid === state.whid && e.deptid === newValue.id)
      });
    }
  };

  const handlereciver = (event, newValue) => {
    if (newValue && typeof newValue === 'object') {
      updateState({
        reciver: newValue.first + " " + newValue.last,
        reciverid: newValue.id,
      });
    } else {
      updateState({ reciver: '', reciverid: '' });
    }
  };

  const handleCategory = (event, newValue) => {
    if (newValue && typeof newValue === 'object') {
      updateState({
        catid: newValue.id,
        category: newValue.category,
        filteritemlist: state.itemsList.filter((e) => e.categoryid === newValue.id),
        itemid: "",
        itemname: "",
        hsn: "",
        cost: "",
        quantity: "",
      });
    } else {
      updateState({
        catid: '',
        category: '',
        filteritemlist: [],
        itemid: "",
        itemname: "",
        hsn: "",
        cost: "",
        quantity: "",
      });
    }
  };

  const handleitem = (event, newValue) => {
    if (newValue && typeof newValue === 'object') {
      const id = newValue.id;
      const itemdata = state.itemsList.filter(e => e.id === id);
      updateState({
        itemid: id,
        itemname: newValue.name,
        quantity: "",
        totalpricewtax: "",
        filteritems: state.whdata.filter(e => e.whid === state.whid && e.itemid === id),
        selectbutton: true,
        type: itemdata[0]?.type,
        hsn: itemdata[0]?.hsn,
        tax: itemdata[0]?.tax,
        cgst: itemdata[0]?.tax / 2,
        sgst: itemdata[0]?.tax / 2,
      });
    } else {
      updateState({
        itemid: '',
        itemname: '',
        quantity: "",
        totalpricewtax: "",
        filteritems: [],
        selectbutton: false,
        type: '',
        hsn: '',
        tax: '',
        cgst: '',
        sgst: '',
      });
    }
  };

  const handleSelect = (id) => {
    if (id !== "") {
      const data = state.filteritems.find((e) => e.id === id);
      updateState({
        avlquantity: data.currentStock,
        cost: data.price,
        selectbutton: false,
        uom: data.uomname,
        brand: data.brand,
        model: data.model,
      });
    }
  };

  const handleRemoveItem = (idx) => {
    const filtereddata = state.additemsList.filter((e, i) => i !== idx);
    updateState({ additemsList: filtereddata });
  };

  const TransporteridChange = (val) => {
    updateState({ transporterid: val });
    if (val.length === 15) {
      const data = {
        tenantId: currentTenant,
        reqparam: val,
      };
      SalesServices.validateGSTIN(data).then((response) => {
        if (response.data.body === null || response.data.body.statusCodeValue === 400) {
          updateState({ err: true, validtrnsid: false });
          Swal.fire({
            title: `Invalid Transporter ID`,
            text: ".",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          });
        } else {
          updateState({ validtrnsid: true });
        }
      });
    } else {
      updateState({ err: false, validtrnsid: false });
    }
  };

  const handleTransporterChange = (event, newValue) => {
    if (!newValue) {
      updateState({ transportername: "", transporterid: "", validtrnsid: false });
    } else {
      updateState({
        transportername: newValue.transname,
        transporterid: newValue.transid,
        validtrnsid: true,
      });
    }
  };

  const onfocus = (e) => {
    e.target.addEventListener('mousewheel', function (e) {
      if (window.document.activeElement.type === 'number') {
        e.preventDefault();
      }
    });
    e.target.addEventListener('keydown', function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
  };

  const handleEwayBillRequiredStatue = (e) => {
    updateState({ ewaybillrequired: e.target.checked });
  };

  // Validation for adding an item
  const validateItem = (values) => {
    const errors = {};
    if (!state.whid) errors.warehouse = "Please Select Org Unit";
    if (state.stockissuetype === "Store" && !state.deptid) errors.department = "Please Select Department/Store";
    if (state.stockissuetype === "OrgUnit" && !state.towhid) errors.towarehouse = "Please Select Receiving Org Unit";
    if (!state.reciverid) errors.reciver = "Please Select User";
    if (!state.catid) errors.category = "Please Select A Category";
    if (!state.itemid) errors.itemname = "Please Select An Item";
    if (!state.stockissuetype) errors.issuetype = "Please select an issue type";
    if (!state.quantity) {
      errors.quantity = "Please Enter Quantity";
    } else if (parseFloat(state.quantity) > parseFloat(state.avlquantity)) {
      errors.quantity = `Quantity Exceeds (available: ${state.avlquantity})`;
    }
    if (!state.uom) errors.uom = "Please Select An UOM";
    if (!state.discription) errors.discription = "Please Enter Description";
    return errors;
  };

  const handleAddItem = (values, { setSubmitting, setErrors }) => {
    const errors = validateItem(values);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      setSubmitting(false);
      return;
    }

    const addstockissue = {
      id: state.id,
      whid: state.whid,
      warehouse: state.warehouse,
      deptid: state.deptid,
      department: state.department,
      catid: state.catid,
      category: state.category,
      itemid: state.itemid,
      itemname: state.itemname,
      cost: state.cost,
      totalquantity: parseFloat(state.quantity),
      quantity: parseFloat(state.quantity),
      uom: state.uom,
      uomid: state.uomid,
      description: state.discription,
      receivedby: state.reciverid,
      createdby: userid,
      tenantid: currentTenant,
    };
    updateState({ additemsList: [...state.additemsList, addstockissue] });
    setSubmitting(false);
  };

  const handleSubmit = () => {
    updateState({ loader: true });
    const data = {
      fromwhid: state.whid,
      deptid: state.stockissuetype === "Store" ? state.deptid : null,
      stocktransfertype: state.stockissuetype,
      towhid: state.stockissuetype === "Store" ? null : state.towhid,
      createdby: userid,
      updatedby: userid,
      receivedby: state.reciverid,
      description: "",
      tenantid: currentTenant,
      vehiclenum: state.vehiclenum,
      transporterid: state.transporterid,
      transportername: state.transportername,
      distance: state.distance,
      vehicletype: state.vehicletype,
      supplytype: state.supplytype,
      transportationmode: state.transportationmode,
      transactiontype: state.transactiontype,
      stocktransferitem: state.additemsList,
      ewaybillrequired: state.ewaybillrequired,
    };
    InventoryService.AddStockTransfer(data)
      .then(() => navigate(-1))
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate('/');
        }
        updateState({ loader: false });
      });
  };

  return (
    <div>

      <Header />
      <Menu />
      <div className="content-wrapper">
        {state.loader && (
          <div className="UI-loading-overlay">
            <div className="UI-spinner"></div>
          </div>
        )}

        <div className="UI-container">
          <div className="UI-card">
            <div className="UI-header">
              <nav className="UI-breadcrumb">
                <Link
                  to="/inventory"
                  className={`UI-breadcrumb-item ${hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                  onMouseEnter={() => setHovered('home')}
                  onMouseLeave={() => setHovered(null)}
                >
                  Home
                </Link>
                <span>/</span>
                <Link
                  to="/stockissue"
                  className={`UI-breadcrumb-item ${hovered === 'stockissue' ? 'UI-breadcrumb-item-hover' : ''}`}
                  onMouseEnter={() => setHovered('stockissue')}
                  onMouseLeave={() => setHovered(null)}
                >
                  Stock Issue
                </Link>
                <span>/</span>
                <span className="UI-breadcrumb-active">{pagename}</span>
              </nav>

              <div className="UI-header-content">
                <div>
                  <h1 className="UI-title">{pagename}</h1>
                  <p className="UI-subtitle">Create a new stock issue or transfer</p>
                </div>
                <div className="UI-header-actions">
                  <button
                    onClick={() => navigate(-1)}
                    className={`UI-btn UI-btn-outline ${hovered === "back" ? "UI-btn-outline-hover" : ""}`}
                    style={{
                      backgroundColor: hovered === "back" ? "#4d4d4d" : "#ffffff",
                      color: hovered === "back" ? "#fff" : "#4d4d4d",
                      transform: hovered === "back" ? "scale(1.02)" : "scale(1)",
                      border: '1px solid #4d4d4d',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={() => setHovered("back")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    ← Back
                  </button>
                </div>
              </div>
            </div>

            <div className="UI-form-container">
              <Formik
                initialValues={{}}
                onSubmit={handleAddItem}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({ errors, isSubmitting, handleSubmit }) => (
                  <Form onSubmit={handleSubmit} autoComplete="off">
                    <div className="UI-form-section">
                      <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>
                        Issue Details
                      </h3>

                      <div className="UI-form-grid">
                        {/* Issue Type */}
                        {/* Issue Type */}
                        <div className="UI-form-group">
                          <label className="UI-label">Issue Type *</label>
                          <Autocomplete
                            options={state.stockissuetypelist}
                            getOptionLabel={(option) => option}
                            value={state.stockissuetype}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                updateState({ stockissuetype: newValue });
                              }
                            }}
                            disabled={state.additemsList.length > 0}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  {...params.inputProps}
                                  className={`UI-input ${errors.issuetype ? 'UI-input-error' : ''}`}
                                  placeholder="Select issue type"
                                />
                              </div>
                            )}
                          />
                          {errors.issuetype && <div className="UI-error-text">{errors.issuetype}</div>}
                        </div>

                        {/* From Warehouse */}
                        <div className="UI-form-group">
                          <label className="UI-label">From Org Unit *</label>
                          <Autocomplete
                            options={state.WarehouseList}
                            getOptionLabel={(option) => option.name}
                            value={state.WarehouseList.find(e => e.id === state.whid) || null}
                            onChange={handlewarehouse}
                            disabled={state.additemsList.length > 0}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  {...params.inputProps}
                                  className={`UI-input ${errors.warehouse ? 'UI-input-error' : ''}`}
                                  placeholder="Select source org unit"
                                />
                              </div>
                            )}
                          />
                          {errors.warehouse && <div className="UI-error-text">{errors.warehouse}</div>}
                        </div>

                        {/* To Warehouse (OrgUnit) or Department (Store) */}
                        {state.stockissuetype === "Store" ? (
                          <div className="UI-form-group">
                            <label className="UI-label">Department/Store *</label>
                            <Autocomplete
                              options={state.departmentList}
                              getOptionLabel={(option) => option.name}
                              value={state.departmentList.find(e => e.id === state.deptid) || null}
                              onChange={handledept}
                              renderInput={(params) => (
                                <div ref={params.InputProps.ref}>
                                  <input
                                    {...params.inputProps}
                                    className={`UI-input ${errors.department ? 'UI-input-error' : ''}`}
                                    placeholder="Select department"
                                  />
                                </div>
                              )}
                            />
                            {errors.department && <div className="UI-error-text">{errors.department}</div>}
                          </div>
                        ) : (
                          <div className="UI-form-group">
                            <label className="UI-label">To Org Unit *</label>
                            <Autocomplete
                              options={state.WarehouseList}
                              getOptionLabel={(option) => option.name}
                              value={state.WarehouseList.find(e => e.id === state.towhid) || null}
                              onChange={handleTowarehouse}
                              disabled={state.additemsList.length > 0}
                              renderInput={(params) => (
                                <div ref={params.InputProps.ref}>
                                  <input
                                    {...params.inputProps}
                                    className={`UI-input ${errors.towarehouse ? 'UI-input-error' : ''}`}
                                    placeholder="Select destination org unit"
                                  />
                                </div>
                              )}
                            />
                            {errors.towarehouse && <div className="UI-error-text">{errors.towarehouse}</div>}
                          </div>
                        )}

                        {/* Receiver */}
                        <div className="UI-form-group">
                          <label className="UI-label">Receiver *</label>
                          <Autocomplete
                            options={state.userList}
                            getOptionLabel={(option) => option.first + " " + option.last}
                            value={state.userList.find(u => u.id === state.reciverid) || null}
                            onChange={handlereciver}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  {...params.inputProps}
                                  className={`UI-input ${errors.reciver ? 'UI-input-error' : ''}`}
                                  placeholder="Select receiver"
                                />
                              </div>
                            )}
                          />
                          {errors.reciver && <div className="UI-error-text">{errors.reciver}</div>}
                        </div>

                        {/* Category */}
                        <div className="UI-form-group">
                          <label className="UI-label">Category *</label>
                          <Autocomplete
                            options={state.CategoryList}
                            getOptionLabel={(option) => option.category}
                            value={state.CategoryList.find(c => c.id === state.catid) || null}
                            onChange={handleCategory}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  {...params.inputProps}
                                  className={`UI-input ${errors.category ? 'UI-input-error' : ''}`}
                                  placeholder="Select category"
                                />
                              </div>
                            )}
                          />
                          {errors.category && <div className="UI-error-text">{errors.category}</div>}
                        </div>

                        {/* Item */}
                        <div className="UI-form-group">
                          <label className="UI-label">Item *</label>
                          <Autocomplete
                            options={state.filteritemlist}
                            getOptionLabel={(option) => option.name}
                            value={state.filteritemlist.find(i => i.id === state.itemid) || null}
                            onChange={handleitem}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  {...params.inputProps}
                                  className={`UI-input ${errors.itemname ? 'UI-input-error' : ''}`}
                                  placeholder="Select item"
                                />
                              </div>
                            )}
                          />
                          {errors.itemname && <div className="UI-error-text">{errors.itemname}</div>}
                        </div>
                      </div>

                      {/* Stock selection table */}
                      {state.selectbutton === true && state.filteritems.length > 0 && (
                        <div className="UI-form-group" style={{ marginTop: '16px' }}>
                          <label className="UI-label">Available Batches</label>
                          <TableContainer className="UI-table-container" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <table className="UI-table">
                              <thead className="UI-table-header" style={{ position: 'sticky', top: 0 }}>
                                <tr>
                                  <th className="UI-th">Item Name</th>
                                  <th className="UI-th">Price</th>
                                  <th className="UI-th">Current Stock</th>
                                  <th className="UI-th">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {state.filteritems.map((e, index) => (
                                  e.currentStock !== 0 && (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8fafc' : '#ffffff' }}>
                                      <td className="UI-td">{e.itemname}</td>
                                      <td className="UI-td">{e.price}</td>
                                      <td className="UI-td">{e.currentStock}</td>
                                      <td className="UI-td">
                                        <button
                                          type="button"
                                          onClick={() => handleSelect(e.id)}
                                          className="UI-btn UI-btn-primary"
                                          style={{ fontSize: '0.7rem', padding: '4px 8px' }}
                                        >
                                          Select
                                        </button>
                                      </td>
                                    </tr>
                                  )
                                ))}
                              </tbody>
                            </table>
                          </TableContainer>
                        </div>
                      )}

                      {/* Selected item details */}
                      {state.itemname && state.selectbutton === false && (
                        <div className="UI-form-grid" style={{ marginTop: '16px' }}>
                          <div className="UI-form-group">
                            <label className="UI-label">Price</label>
                            <input type="text" className="UI-input UI-input-disabled" value={state.cost || 0} disabled />
                          </div>
                          <div className="UI-form-group">
                            <label className="UI-label">Brand</label>
                            <input type="text" className="UI-input UI-input-disabled" value={state.brand || ''} disabled />
                          </div>
                          <div className="UI-form-group">
                            <label className="UI-label">Model</label>
                            <input type="text" className="UI-input UI-input-disabled" value={state.model || ''} disabled />
                          </div>
                          <div className="UI-form-group">
                            <label className="UI-label">UOM *</label>
                            <input type="text" className="UI-input UI-input-disabled" value={state.uom || ''} disabled />
                            {errors.uom && <div className="UI-error-text">{errors.uom}</div>}
                          </div>
                          <div className="UI-form-group">
                            <label className="UI-label">Quantity (Available: {state.avlquantity}) *</label>
                            <input
                              type="number"
                              className={`UI-input ${errors.quantity ? 'UI-input-error' : ''}`}
                              value={state.quantity}
                              onChange={(e) => updateState({ quantity: e.target.value })}
                              onFocus={onfocus}
                              min="0"
                              step="0.01"
                            />
                            {errors.quantity && <div className="UI-error-text">{errors.quantity}</div>}
                          </div>
                          <div className="UI-form-group" style={{ gridColumn: 'span 3' }}>
                            <label className="UI-label">Description *</label>
                            <textarea
                              className={`UI-textarea ${errors.discription ? 'UI-input-error' : ''}`}
                              value={state.discription}
                              onChange={(e) => updateState({ discription: e.target.value })}
                              placeholder="Enter description"
                              rows="2"
                            />
                            {errors.discription && <div className="UI-error-text">{errors.discription}</div>}
                          </div>
                        </div>
                      )}

                      <div className="UI-btn-actions" style={{ justifyContent: 'flex-start' }}>
                        <button
                          type="submit"
                          disabled={isSubmitting || !state.itemid || !state.quantity || !state.discription}
                          className={`UI-btn UI-btn-primary ${hovered === "addToList" ? "UI-btn-primary-hover" : ""}`}
                          style={{
                            opacity: (isSubmitting || !state.itemid || !state.quantity || !state.discription) ? 0.6 : 1,
                            transform: hovered === "addToList" ? "scale(1.07)" : "scale(1)",
                          }}
                          onMouseEnter={() => setHovered("addToList")}
                          onMouseLeave={() => setHovered(null)}
                        >
                          Add to List
                        </button>
                      </div>
                    </div>

                    {/* Added items table */}
                    {state.additemsList.length > 0 && (
                      <div className="UI-form-section">
                        <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>
                          Items to Issue ({state.additemsList.length})
                        </h3>
                        <TableContainer className="UI-table-container" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                          <table className="UI-table">
                            <thead className="UI-table-header" style={{ position: 'sticky', top: 0 }}>
                              <tr>
                                <th className="UI-th">Item Name</th>
                                <th className="UI-th">Category</th>
                                <th className="UI-th">Price</th>
                                <th className="UI-th">Quantity</th>
                                <th className="UI-th">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {state.additemsList.map((e, index) => (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8fafc' : '#ffffff' }}>
                                  <td className="UI-td">{e.itemname}</td>
                                  <td className="UI-td">{e.category}</td>
                                  <td className="UI-td">{e.cost}</td>
                                  <td className="UI-td">{e.totalquantity} {e.uom}</td>
                                  <td className="UI-td">
                                    <button
                                      type="button"
                                      onClick={() => handleRemoveItem(index)}
                                      className="UI-btn UI-btn-outline"
                                      style={{ fontSize: '0.7rem', padding: '2px 6px', color: '#dc2626', borderColor: '#dc2626' }}
                                    >
                                      Remove
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </TableContainer>
                      </div>
                    )}

                    {/* E-Way Bill section */}
                    {ccountry === "India" && einvoice && state.additemsList.length > 0 && (
                      <div className="UI-form-section">
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={state.ewaybillrequired}
                                onChange={handleEwayBillRequiredStatue}
                                name="ewaybillrequired"
                                color="primary"
                              />
                            }
                            label="E-Way Bill Required"
                          />
                        </FormGroup>

                        {state.ewaybillrequired && (
                          <div className="UI-form-grid" style={{ marginTop: '16px' }}>
                            <h4 className="UI-section-title" style={{ gridColumn: 'span 4' }}>E-Way Bill Details</h4>

                            <div className="UI-form-group">
                              <TextField
                                label="Vehicle No."
                                variant="standard"
                                value={state.vehiclenum || ''}
                                onChange={(e) => updateState({ vehiclenum: e.target.value })}
                                error={state.err && !state.vehiclenum}
                                helperText={state.err && !state.vehiclenum ? "Empty field!" : " "}
                                fullWidth
                              />
                            </div>

                            <div className="UI-form-group">
                              <TextField
                                type="number"
                                label="Approx Distance (Km)"
                                variant="standard"
                                value={state.distance}
                                onChange={(e) => updateState({ distance: e.target.value })}
                                error={state.err && !state.distance}
                                helperText={state.err && !state.distance ? "Empty field!" : " "}
                                fullWidth
                              />
                            </div>

                            <div className="UI-form-group">
                              <FormControl variant="standard" fullWidth>
                                <InputLabel>Mode of Transportation</InputLabel>
                                <Select
                                  value={state.transmode}
                                  onChange={(e) => updateState({ transmode: e.target.value })}
                                >
                                  {state.deliverymethods.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>

                            <div className="UI-form-group">
                              <FormControl variant="standard" fullWidth>
                                <InputLabel>Vehicle Type</InputLabel>
                                <Select
                                  value={state.vehicletype}
                                  onChange={(e) => updateState({ vehicletype: e.target.value })}
                                >
                                  <MenuItem value="R">Regular</MenuItem>
                                  <MenuItem value="O">ODC</MenuItem>
                                </Select>
                              </FormControl>
                            </div>

                            <div className="UI-form-group">
                              <FormControl variant="standard" fullWidth>
                                <InputLabel>Transaction Type</InputLabel>
                                <Select
                                  value={state.transactiontype}
                                  onChange={(e) => updateState({ transactiontype: e.target.value })}
                                >
                                  <MenuItem value={1}>Regular</MenuItem>
                                  <MenuItem value={2}>Bill To - Ship To</MenuItem>
                                  <MenuItem value={3}>Bill From - Dispatch From</MenuItem>
                                  <MenuItem value={4}>Combination of 2 and 3</MenuItem>
                                </Select>
                              </FormControl>
                            </div>

                            <div className="UI-form-group">
                              <FormControl variant="standard" fullWidth>
                                <InputLabel>Transportation Mode</InputLabel>
                                <Select
                                  value={state.transportationmode}
                                  onChange={(e) => updateState({ transportationmode: e.target.value })}
                                >
                                  <MenuItem value="1">Road</MenuItem>
                                  <MenuItem value="2">Rail</MenuItem>
                                  <MenuItem value="3">Air</MenuItem>
                                  <MenuItem value="4">Ship</MenuItem>
                                  <MenuItem value="5">inTransit</MenuItem>
                                </Select>
                              </FormControl>
                            </div>

                            <div className="UI-form-group">
                              <FormControl variant="standard" fullWidth>
                                <InputLabel>Supply Type</InputLabel>
                                <Select
                                  value={state.supplytype}
                                  onChange={(e) => updateState({ supplytype: e.target.value })}
                                >
                                  <MenuItem value="I">Inward</MenuItem>
                                  <MenuItem value="O">Outward</MenuItem>
                                </Select>
                              </FormControl>
                            </div>

                            <div className="UI-form-group" style={{ gridColumn: 'span 4' }}>
                              <FormGroup row>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={state.transidreq}
                                      onChange={() => updateState({ transidreq: !state.transidreq, transporterid: null, transportername: null })}
                                      name="transidreq"
                                      color="primary"
                                    />
                                  }
                                  label="Add transporter details for Part A?"
                                />
                              </FormGroup>
                            </div>

                            {state.transidreq && (
                              <>
                                <div className="UI-form-group" style={{ gridColumn: 'span 4', display: 'flex', gap: '16px' }}>
                                  <button
                                    type="button"
                                    className={`UI-btn ${!state.transporterselectiontype ? 'UI-btn-primary' : 'UI-btn-outline'}`}
                                    onClick={() => updateState({ transporterselectiontype: false, transportername: "", transporterid: "" })}
                                  >
                                    Enter Manually
                                  </button>
                                  <button
                                    type="button"
                                    className={`UI-btn ${state.transporterselectiontype ? 'UI-btn-primary' : 'UI-btn-outline'}`}
                                    onClick={() => updateState({ transporterselectiontype: true, transportername: "", transporterid: "" })}
                                  >
                                    Select from List
                                  </button>
                                </div>

                                {state.transporterselectiontype ? (
                                  <>
                                    <div className="UI-form-group">
                                      <Autocomplete
                                        options={state.transporterslist}
                                        getOptionLabel={(option) => option.transname}
                                        onChange={handleTransporterChange}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="standard"
                                            label="Select Transporter"
                                            error={state.err && !state.transportername}
                                            helperText={state.err && !state.transportername ? "Empty field!" : " "}
                                            fullWidth
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="UI-form-group">
                                      <TextField
                                        label="Transporter ID"
                                        variant="standard"
                                        value={state.transporterid || ''}
                                        disabled
                                        fullWidth
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="UI-form-group">
                                      <TextField
                                        label="Transporter Name"
                                        variant="standard"
                                        value={state.transportername || ''}
                                        onChange={(e) => updateState({ transportername: e.target.value, err: false })}
                                        error={state.err && !state.transportername}
                                        helperText={state.err && !state.transportername ? "Empty field!" : " "}
                                        fullWidth
                                      />
                                    </div>
                                    <div className="UI-form-group">
                                      <TextField
                                        label="Transporter ID"
                                        variant="standard"
                                        value={state.transporterid || ''}
                                        onChange={(e) => TransporteridChange(e.target.value)}
                                        error={(state.err && !state.transporterid) || state.validtrnsid === false}
                                        helperText={
                                          state.err && !state.transporterid ? "Empty field!" :
                                            state.validtrnsid === false ? "Invalid Transporter ID" : " "
                                        }
                                        fullWidth
                                      />
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Submit buttons */}
                    {state.additemsList.length > 0 && (
                      <div className="UI-btn-actions">
                        <Link
                          to="/stockissue"
                          className={`UI-btn UI-btn-outline ${hovered === "cancel" ? "UI-btn-outline-hover" : ""}`}
                          style={{
                            backgroundColor: hovered === "cancel" ? "#4d4d4d" : "#ffffff",
                            color: hovered === "cancel" ? "#fff" : "#4d4d4d",
                            transform: hovered === "cancel" ? "scale(1.03)" : "scale(1)",
                            border: '1px solid #4d4d4d',
                            textDecoration: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onMouseEnter={() => setHovered("cancel")}
                          onMouseLeave={() => setHovered(null)}
                        >
                          Cancel
                        </Link>
                        <button
                          type="button"
                          onClick={handleSubmit}
                          disabled={state.loader}
                          className={`UI-btn UI-btn-primary ${hovered === "submit" ? "UI-btn-primary-hover" : ""}`}
                          style={{
                            opacity: state.loader ? 0.6 : 1,
                            transform: hovered === "submit" ? "scale(1.07)" : "scale(1)",
                          }}
                          onMouseEnter={() => setHovered("submit")}
                          onMouseLeave={() => setHovered(null)}
                        >
                          {state.loader ? <><Spinner animation="border" size="sm" /> Saving...</> : 'Save'}
                        </button>
                      </div>
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AddStockIssue;